import { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import usuarioSinFoto from "../images/usuario.png";

function DropdownExample() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Configuración de URL dinámica
  const isLocal = window.location.hostname === "localhost";
  const API_BASE_URL = isLocal ? "http://localhost:4000" : "https://vetladradoc.uy";

  // 2. Consultar el estado de la sesión al cargar el componente
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/status`, {
          method: 'GET',
          credentials: 'include' // Obligatorio para que Passport reconozca la sesión
        });
        
        if (response.ok) {
          const data = await response.json();
          // Asumiendo que tu endpoint devuelve { authenticated: true, user: {...} }
          if (data.auth) {
            setUser(data.user);
          }
        }
      } catch (error) {
        console.error("Error al verificar autenticación:", error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [API_BASE_URL]);

  const logout = async () => {
    try {
      await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
      // Limpiamos el estado y redirigimos
      setUser(null);
      window.location.href = "/";
    } catch (error) {
      console.error("Error en el logout:", error);
      window.location.href = "/";
    }
  };

  if (loading) return null; // O un pequeño spinner

  return (
    <Dropdown>
      <Dropdown.Toggle variant="" id="dropdown-basic" style={{ border: 'none', background: 'none' }}>
        <img src={usuarioSinFoto} alt="Usuario" height={'75px'} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {user ? (
          <>
            {/* Si está logueado: Nombre, Cambiar Contraseña y Logout */}
            <Dropdown.Item disabled style={{ color: '#333', fontWeight: 'bold' }}>
              {user.Nombre} {user.Apellido}
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item href="/#/reset-password">
              Cambiar Contraseña
            </Dropdown.Item>
            <Dropdown.Item onClick={logout} style={{ color: '#dc3545' }}>
              Cerrar Sesión
            </Dropdown.Item>
          </>
        ) : (
          <>
            {/* Si NO está logueado: Solo Login */}
            <Dropdown.Item href="/#/login">
              Login
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownExample;